var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-dropdown",
    {
      attrs: {
        disabled: !_vm.hasActionsMenu(_vm.row),
        position: "is-bottom-left"
      }
    },
    [
      _c("sc-button", {
        attrs: {
          slot: "trigger",
          theme: "primary",
          text: "Ações",
          icon: "caret-down"
        },
        slot: "trigger"
      }),
      _vm._v(" "),
      _vm._l(_vm.actionsList, function(action) {
        return _vm.hasActionMethod(_vm.row, action.method)
          ? _c(
              "sc-dropdown-item",
              {
                key: action.method,
                staticClass: "has-text-left",
                on: {
                  click: function($event) {
                    _vm.executeActionMethod(_vm.row, action.method)
                  }
                }
              },
              [_vm._v("\n    " + _vm._s(action.name) + "\n  ")]
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43bdcb63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bdcb63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-psl/features/list/components/ScActionsMenu.vue
// module id = null
// module chunks = 